import React, { memo, useState } from "react";
import { validators } from "investira.sdk";
import {
  Stack,
  Card,
  CardContent,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  CardHeader,
} from "investira.react.components";
import DivergenciasChart from "./DivergenciasChart";
import TipoAtivoChart from "./TipoAtivoChart";

const Graphs = memo((props) => {
  const { data = [] } = props;

  const [alignment, setAlignment] = useState("divergencias");

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const xResumo = data.response?.resumo;

  if (validators.isNull(xResumo)) {
    return null;
  }

  return (
    <Stack
      sx={{ gap: 2 }}
      component="section"
      flexGrow={1}
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
    >
      <Card sx={{ flex: 1, minHeight: 0 }}>
        <CardHeader
          title="Divergências"
          titleTypographyProps={{ variant: "h6" }}
        />
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            minHeight: "200px",
          }}
        >
          <DivergenciasChart data={xResumo.estatisticas.divergencias} />
        </CardContent>
      </Card>
      <Card sx={{ flex: 1, minHeight: 0 }}>
        <CardHeader
          title="Tipos de Ativos Divergentes"
          titleTypographyProps={{ variant: "h6" }}
        />
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
            minHeight: "200px",
          }}
        >
          <TipoAtivoChart data={xResumo.ativos} />
        </CardContent>
      </Card>
    </Stack>
  );
});

export default Graphs;
